/**
 * Самолечение после выкатки новой версии.
 *
 * Vite даёт файлам сборки имена с хешем содержимого. Открытая до выкатки
 * страница помнит старые имена, а после деплоя их на сервере уже нет: любая
 * ленивая часть приложения — ежедневный отчёт, PDF, выгрузки — не грузится,
 * и человек видит «Failed to fetch dynamically imported module».
 *
 * Хуже того, nginx отдаёт на пропавший файл не 404, а index.html с кодом 200,
 * поэтому браузер даже не может отличить «файла нет» от сетевого сбоя.
 *
 * Vite сообщает о таком через событие vite:preloadError. Единственное разумное
 * действие — перезагрузить страницу: она возьмёт свежий index.html с новыми
 * именами.
 */
const KEY = 'instafarm.stale-chunk-reload-at';
/**
 * Сколько ждать между перезагрузками. Защита от петли: если новая версия не
 * лечит проблему, вторая перезагрузка ничего не изменит, а человек окажется в
 * бесконечном цикле. Через минуту попробовать снова уже разумно — за это время
 * могла выйти следующая выкатка.
 */
const COOLDOWN_MS = 60_000;

/** Перезагружаться ли сейчас. Чистая функция — вся логика решения здесь. */
export function shouldReload(lastReloadAt: number | null, now: number): boolean {
  if (lastReloadAt === null) return true;
  return now - lastReloadAt > COOLDOWN_MS;
}

function readLast(): number | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (!shouldReload(readLast(), Date.now())) return;
    try {
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch {
      // Хранилище недоступно — перезагрузимся без защиты от повтора.
    }
    event.preventDefault();
    window.location.reload();
  });
}
